export enum AffiliateType {
  SIGN_UP = 'SIGN_UP',
  INTERNAL = 'INTERNAL',
}
